import { type ReactNode } from "react";

import { BasicModalShell } from "@/components/shared/BasicModalShell";

/**
 * Opinionated "bottom sheet" wrapper around `BasicModalShell`.
 *
 * This avoids copy/pasting stringly-typed Tailwind class recipes across modals.
 */
export function SheetModalShell({
  isOpen,
  onClose,
  onAfterClose,
  children,
  sheetHeightClassName = "h-[85vh]",
  showCloseButton = true,
  closeButtonClassName,
  panelClassName,
  overlayClassName,
  scrollClassName,
}: {
  isOpen: boolean;
  onClose: () => void;
  onAfterClose?: () => void;
  children: ReactNode;
  /**
   * Sheet height classes (must be literal Tailwind classes so they are generated).
   * Examples: `h-[70vh]`, `h-[85vh]`, `h-[85vh] sm:h-[80vh]`.
   */
  sheetHeightClassName?: string;
  showCloseButton?: boolean;
  closeButtonClassName?: string;
  panelClassName?: string;
  overlayClassName?: string;
  scrollClassName?: string;
}) {
  return (
    <BasicModalShell
      isOpen={isOpen}
      onClose={onClose}
      onAfterClose={onAfterClose}
      overlayClassName={`items-end md:items-center md:p-4 ${overlayClassName ?? ""}`}
      panelClassName={`${sheetHeightClassName} rounded-t-2xl sm:rounded-t-2xl sm:max-w-none md:h-auto md:rounded-2xl ${
        panelClassName ?? ""
      }`}
      scrollClassName={`overflow-hidden items-stretch ${scrollClassName ?? ""}`}
      showCloseButton={showCloseButton}
      closeButtonClassName={closeButtonClassName}
    >
      {children}
    </BasicModalShell>
  );
}
